<template>
  <div v-if="isShown" class="cookie-banner">
    <div class="cookie-row">

      <!-- LEFT -->
      <div class="cookie-left">
        <strong>
          {{ findText(['Cookies Einstellungen', 'Cookie Settings']) }}
        </strong>

        <p>
          {{ findText([
            'Wir setzen auf dieser Internetseite Cookies ein. Einige sind technisch erforderlich, andere dienen Statistik und Marketing.',
            'We use cookies on this website. Some are necessary, others are for statistics and marketing.'
          ]) }}
        </p>

        <div class="options">

          <!-- REQUIRED -->
          <label class="checkbox-item disabled">
            <input type="checkbox" checked disabled />
            {{ findText(['Notwendig', 'Necessary']) }}
          </label>

          <!-- STATISTICS -->
          <label class="checkbox-item" :class="{ active: statistik }">
            <input type="checkbox" v-model="statistik" />
            {{ findText(['Statistik (Google Analytics)', 'Statistics (Google Analytics)']) }}
          </label>

          <!-- GOOGLE ADS -->
          <label class="checkbox-item" :class="{ active: marketingGoogle }">
            <input type="checkbox" v-model="marketingGoogle" />
            {{ findText(['Marketing (Google Ads)', 'Marketing (Google Ads)']) }}
          </label>

          <!-- LINKEDIN -->
          <label class="checkbox-item" :class="{ active: marketingLinkedIn }">
            <input type="checkbox" v-model="marketingLinkedIn" />
            {{ findText(['Marketing (LinkedIn)', 'Marketing (LinkedIn)']) }}
          </label>

        </div>
      </div>

      <!-- RIGHT -->
      <div class="cookie-right">
        <button class="btn" @click="declineAll">
          {{ findText(['Ablehnen', 'Decline']) }}
        </button>

        <button class="btn" @click="saveSelection">
          {{ findText(['Speichern', 'Save']) }}
        </button>

        <button class="btn primary" @click="acceptAll">
          {{ findText(['Alle akzeptieren', 'Accept All']) }}
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import store from "@/store";
import {
  cookieConsent,
  saveConsentToCookie,
  loadConsentFromCookie,
  activateTrackingScripts,
  trackPageView,
  resetPageViewFlag
} from "@/cookieStore";

export default {
  setup() {

   const isShown = ref(false);
   const route = useRoute();


    // =======================
    // DEFAULT = ALL ON
    // =======================
    const statistik = ref(true);
    const marketingGoogle = ref(true);
    const marketingLinkedIn = ref(true);

    const currentLang = computed(() => store.getters.lang || "DE");

    const findText = (t) =>
      currentLang.value === "EN" ? t[1] : t[0];

    // =======================
    // SAVE
    // =======================
    const saveSelection = () => {
      saveConsentToCookie(
        statistik.value,
        marketingGoogle.value,
        marketingLinkedIn.value
      );
      cookieConsent.value.statistik = statistik.value;
      cookieConsent.value.marketingGoogle = marketingGoogle.value;
      cookieConsent.value.marketingLinkedIn = marketingLinkedIn.value;

      activateTrackingScripts(route);
      resetPageViewFlag();
      trackPageView(route.path);

      isShown.value = false;
    };

    // =======================
    // ACCEPT ALL
    // =======================
    const acceptAll = () => {
      statistik.value = true;
      marketingGoogle.value = true;
      marketingLinkedIn.value = true;

      cookieConsent.value.statistik = true;
      cookieConsent.value.marketingGoogle = true;
      cookieConsent.value.marketingLinkedIn = true;

      saveSelection();
    };

    // =======================
    // DECLINE ALL
    // =======================
    const declineAll = () => {
      statistik.value = false;
      marketingGoogle.value = false;
      marketingLinkedIn.value = false;

      cookieConsent.value.statistik = false;
      cookieConsent.value.marketingGoogle = false;
      cookieConsent.value.marketingLinkedIn = false;

      saveSelection();
    };

    // =======================
    // LOAD COOKIE
    // =======================
    onMounted(() => {
      const saved = loadConsentFromCookie();

      if (saved) {
    statistik.value = saved.statistik;
    marketingGoogle.value = saved.marketingGoogle;
    marketingLinkedIn.value = saved.marketingLinkedIn;

    isShown.value = false;
  } else {
    isShown.value = true;
  }
});

    return {
      isShown,
      statistik,
      marketingGoogle,
      marketingLinkedIn,
      saveSelection,
      acceptAll,
      declineAll,
      findText
    };
  }
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #f4f4f4;
  padding: 15px 25px;
  border-top: 1px solid #ddd;
  z-index: 9999;
  font-size: 14px;
}

.cookie-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.cookie-left {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.options {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  cursor: pointer;
  transition: 0.2s;
}

.checkbox-item.active {
  border: 1px solid red;
  background: #fff5f5;
}

.checkbox-item.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cookie-right {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 7px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  min-width: 110px;
}

.btn:hover {
  opacity: 0.85;
}

.btn.primary {
  background: #495057;
}
</style>
